import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import Venster from '../Venster.jsx';

/**
 * De Arcadehal: alle spelletjes als tegels, elk met een Nieuw!-pil.
 *
 * Twee naast elkaar op een groot scherm en onder elkaar op een telefoon. Elke
 * tegel is een knop naar het spel; het venster gaat daarbij niet dicht, want het
 * spel legt zich er toch bovenop.
 */
export default function Arcade({ v }) {
  if (!v.showArcade) return null;
  return (
    <Venster v={v} venster={v.arcadeVenster} titel={v.arcadeTitel} onSluit={v.closeArcade}>
      <div style={css(v.arcadePanelStyle)}>
        <div style={css(v.arcadeRasterStyle)}>
          {toList(v.arcadeSpellen).map((s, $index) => (
            <React.Fragment key={$index}>
              <button onClick={s?.onClick} disabled={s?.uit} className="gp-btn" title={s?.titelAttr} style={css(s?.style)}>
                <span style={{ "display": "flex", "flexDirection": "column", "alignItems": "flex-start", "gap": "7px", "width": "100%", "minWidth": "0" }}>
                  <span style={css(s?.vakStyle)}><Interp v={s?.icoon} /></span>
                  <span style={css(s?.titelStyle)}><Interp v={s?.titel} /></span>
                </span>
                <span style={css(s?.regelStyle)}><Interp v={s?.regel} /></span>
                <span style={css(s?.badgeStyle)}>
                  <Interp v={s?.badge} />
                </span>
              </button>
            </React.Fragment>
          ))}
        </div>
      </div>
    </Venster>
  );
}
